// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { Router } from 'react-router';
import hoistNonReactStatics from 'hoist-non-react-statics';

type Props = {
  children: (router: Router) => React.Node,
};

// Function As Child
export class RouterConsumer extends React.Component<Props, {}> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  render() {
    return this.props.children(this.context.router);
  }
}

// Higher Order Components
export function withRouter(Component: *) {
  function RoutedComponent(props: *) {
    return <RouterConsumer>{router => <Component {...props} router={router} />}</RouterConsumer>;
  }

  return hoistNonReactStatics(RoutedComponent, Component);
}
